import { useEffect, useState } from "react";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { T2 } from "../../../styles/titles";
import {
  FormValues,
  SettlementsTableData,
  TotalsData,
} from "../recebiveis/types";
import { Container } from "../recebiveis/styles";
import SalesService from "./service/vendasService";
import { FormFilter } from "./components/filter/filters";
import { LiveTable } from "./components/liveTable/liveTable";
import { Totals } from "./components/totals/totals";
import { Button } from "../../terminaisPhoebus/styles";
import VendaServices from "../../transacoesErepasses/painelDeVendas/services/VendaServices";
import { can, PortalPermissions } from "../../../config/permissions";

const DetLiqVendas: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState<SettlementsTableData | null>(null);
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totals, setTotals] = useState<TotalsData | null>(null);
  const [filterData, setFilterData] = useState<any>(null);
  const vendasService = new SalesService();

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const data = await vendasService.getSales(
        (currentPage - 1) * pageSize,
        pageSize,
        filterData
      );
      setTotals({
        totalValue: data.totalValue,
        totalLiquidValue: data.totalLiquidValue,
        totalMdrValue: data.totalMdrValue,
        totalPartnerMdrValue: data.totalPartnerMdrValue,
        totalAnticipation: data.totalAnticipation,
        totalPartnerAnticipation: data.totalPartnerAnticipation,
        totalCost: data.totalCost,
        totalPartnerCost: data.totalPartnerCost,
        totalAcquirer: data.totalAcquirer,
        totalRevenue: data.totalRevenue,
        totalPartnerRevenue: data.totalPartnerRevenue,
        takeRate: data.takeRate,
        totalRecords: data.count,
      });
      setTableData({
        records: data.records || [],
        count: data.count || 0,
      });
    } catch (error) {
      console.log("Erro ao buscar os detalhes da liquidação", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (filterData) {
      setCurrentPage(1);
    }
  }, [filterData]);

  useEffect(() => {
    if (filterData) {
      fetchData();
    }
  }, [filterData, currentPage, pageSize]);

  const handleDownload = async (filterData?: FormValues) => {
    setIsLoading(true);
    try {
      const blob = await vendasService.downloadVendasXls(
        (currentPage - 1) * pageSize,
        pageSize,
        filterData
      );

      if (blob) {
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = "Det Liq Vendas.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error("Erro ao baixar o arquivo:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />

      <T2>Detalhamento Liquidação - Vendas</T2>
      {totals && <Totals data={totals} />}
      <FormFilter getFilters={(data) => setFilterData(data)} />

      <div>
        {can(PortalPermissions.liquidacao.vendas.exportar) && (
          <Button
            onClick={() => {
              handleDownload(filterData);
            }}
            style={{
              marginBottom: "25px",
              marginRight: "24px",
              width: "150px",
              alignSelf: "start",
            }}
          >
            Download xlsx
          </Button>
        )}
      </div>

      {tableData && (
        <LiveTable
          data={tableData}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize}
          isAdmin={filterData.isAdmin}
        />
      )}
    </Container>
  );
};

export default DetLiqVendas;
